export function getAccountPagePath({
    accountId,
}: {
    accountId: number;
}): string {
    return `/accounts/${accountId}`;
}

export function getAccountsPagePath(): string {
    return `/accounts`;
}

export function getClientsPagePath(): string {
    return `/clients`;
}

export function getClientPagePath({
    accountId,
}: {
    accountId: number;
}): string {
    return `/clients/${accountId}`;
}

export function getOrderRequestPagePath({
    orderRequestId,
}: {
    orderRequestId: number;
}): string {
    return `/orderRequests/${orderRequestId}`;
}

export function getOrderRequestsPagePath(): string {
    return `/orderRequests`;
}

export function getOrderSalePagePath({
    orderSaleId,
}: {
    orderSaleId: number;
}): string {
    return `/orderSales/${orderSaleId}`;
}

export function getOrderSalesPagePath(): string {
    return `/orderSales`;
}
